import { createAsyncThunk } from "@reduxjs/toolkit";
import { IOperationalUpdate } from "./operationalUpdates.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { APIError } from "../../constants/types";
import { api } from "../../api/api";
import { ERROR_MESSAGES } from "../../constants/enums";
import { uploadMultipleFile } from "../../features/FileUpload/utils";
import { getUniqueId } from "../../helpers";
import { IFileUpload } from "../../features/FileUpload/components/FileUpload.type";

export const fetchOperationalUpdatesList = createAsyncThunk<
  {
    data: IOperationalUpdate[];
  },
  {
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    status: string;
    date: IDataTableV2DateState["dates"];
    searchValue: IDatatableV2AdvancedSearchFilter;
  },
  { rejectValue: APIError }
>(
  "operationalUpdates/fetchOperationalUpdatesList",
  async (
    { pageNumber, rowsInPerPage, limit, status, date, searchValue },
    { rejectWithValue },
  ) => {
    try {
      let finalUrl = `/general/get-opeartional-updates?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/general/get-opeartional-updates??pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IOperationalUpdate[] = res.data.data;
      const finalData: IOperationalUpdate[] = [];
      if (data.length > 0) {
        for (const item of data) {
          const finalAtatchments: IFileUpload[] = [];
          for (const attachment of (item.attachments || []) as any) {
            finalAtatchments.push({
              file: null,
              key: getUniqueId(),
              path: attachment,
            });
          }
          finalData.push({
            ...item,
            attachments: finalAtatchments,
          });
        }
      }
      const totalRecords = res.data.totalRecords;

      return {
        data: finalData,
        totalRecords,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const upsertOperationalUpdate = createAsyncThunk<
  {
    data: string;
  },
  {
    payload: IOperationalUpdate;
  },
  { rejectValue: APIError }
>(
  "operationalUpdates/upsertOperationalUpdate",
  async ({ payload }, { rejectWithValue, dispatch }) => {
    try {
      const asPayload = {
        name: payload.name,
      };
      const { paths } = await uploadMultipleFile(
        payload.attachments || [],
        "OPERATIONAL_UPDATES",
        asPayload,
      );

      await api.post(`/general/upsert-opeartional-updates`, {
        ...payload,
        attachments: paths,
      });

      return {
        data: "Operational update saved successfully",
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);
